// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import * as MuiCore from '@material-ui/core';


/*
 * Popover used for various detail boxes
 */

const styles = theme => ({
  popper : {
    '& .MuiPopover-paper' : {
      borderColor: theme.palette.primary.main,
      // borderWidth: 2,
      borderStyle: 'solid',
      borderRadius: 20,
      overflow: 'hidden',
    },
  },
  root : {
    padding: 20,
    overflow: 'hidden',
  },
  title : {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    ...theme.typography.h6,
    marginLeft: 20,
  },
  detailArea : {
    maxHeight: '70vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingBottom: 10,
    paddingTop: 10,
  },
  topBar : {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
  },
  raisedIcon : {
    height: 60,
    width: 60,
    borderRadius: 30,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: theme.shadows[8],
  },
});


class OutlinedPopover extends Component {
  state = {
    center : { top: 0, left : 0},
    open :  false,
  }

  updateCenter = () => {
    this.setState({ center: { top: window.innerHeight / 2, left: window.innerWidth / 2},
                    open : false});
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateCenter);
    this.updateCenter();
    
    if (this.props.open !== this.state.open) {
      this.setState({open: this.props.open});
    }
  }
  
  componentDidUpdate() {
    if (this.props.open !== this.state.open) {
      this.setState({open: this.props.open});
    }
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateCenter);
  }
  
  render() {
    const { classes, icon, onClose, children, title } = this.props;
    
    return(
      <MuiCore.Dialog open={this.state.open}
                       anchorPosition={this.state.center}
                       className={classes.popper}
                       style={this.props.style}
                       maxWidth={this.props.maxWidth}
                       anchorReference='anchorPosition'
                       anchorOrigin={{ horizontal: 'center',
                                       vertical: 'center'}}
                       onClose={onClose}>
        <div className={classes.root}>
          <MuiCore.Hidden xlDown={!Boolean(icon) && !Boolean(title)}>
            <div className={classes.topBar}>
              {/* <div className={classes.raisedIcon}>
                {icon}
              </div> */}
              <div className={classes.title} style={{ flexGrow: 1, fontFamily: 'Sofia-bold' }}>
                {title}
              </div>
              <div>
                <MuiCore.IconButton onClick={onClose}>
                  <CloseIcon/>
                </MuiCore.IconButton>
              </div>
            </div>
          </MuiCore.Hidden>
          <div className={classes.detailArea}>
            {children}
          </div>
        </div>
      </MuiCore.Dialog>
    );
  }
}

OutlinedPopover.propTypes = {
  open : PropTypes.bool.isRequired,
  icon : PropTypes.object,
  title : PropTypes.string,
  onClose : PropTypes.func.isRequired,
  maxWidth: PropTypes.string,
}

OutlinedPopover.defaultProps = {
  maxWidth: 'sm'
}


export default withStyles(styles)(OutlinedPopover);

